import { Injectable } from '@angular/core';
import { RokezzzPlatformService } from 'src/app/rokezzz/platform/services/platform.service';

@Injectable({
    providedIn: 'root'
})
export class RokezzzLocalStorageService {
    public constructor(
        private readonly rokezzzPlatformService: RokezzzPlatformService,
    ) { }

    public setItem(key: string, value: string): void {
        if (this.rokezzzPlatformService.isPlatformBrowser()) {
            localStorage.setItem(key, value);
        }
    }

    public getItem(key: string): string | null {
        if (this.rokezzzPlatformService.isPlatformBrowser()) {
            return localStorage.getItem(key);
        }

        return null;
    }

    public removeItem(key: string): void {
        if (this.rokezzzPlatformService.isPlatformBrowser()) {
            localStorage.removeItem(key);
        }
    }
}
